export const layoutCssVars = {
  SMALL: {
    '--news-image-height': '180px',
    '--news-image-height-tablet': '145px',
    '--news-image-height-mobile': '145px',
    '--news-title-lines': 2,
    '--news-title-lines-tablet': 2,
    '--news-title-lines-mobile': 2
  },
  MIDDLE: {
    '--news-image-height': '250px',
    '--news-image-height-tablet': '145px',
    '--news-image-height-mobile': '145px',
    '--news-title-lines': 2,
    '--news-title-lines-tablet': 2,
    '--news-title-lines-mobile': 2
  },
  LARGE: {
    '--news-image-height': '500px',
    '--news-image-height-tablet': '300px',
    '--news-image-height-mobile': '145px',
    '--news-title-lines': 1,
    '--news-title-lines-tablet': 1,
    '--news-title-lines-mobile': 2
  }
};
